<template>
  <div class="fin-drawer-backdrop fin-unmatched-backdrop" @click.self="$emit('close')">
    <div class="fin-modal fin-unmatched-modal">
      <div class="fin-drawer-head">
        <div>
          <div class="fin-drawer-title">Kodet që nuk u përputhën</div>
          <div class="fin-drawer-sub">Kode nga Financa që nuk kanë kartelë te ne. Shkarkojini për t’i lidhur me Kodi f2 / kodin e produktit.</div>
        </div>
        <button type="button" class="fin-btn" @click="$emit('close')"><i class="fa fa-times"></i> Mbyll</button>
      </div>

      <div class="fin-unmatched-tabs">
        <button type="button" class="fin-tab" :class="{ active: tab === 'warehouses' }" @click="tab = 'warehouses'">
          Magazina
          <span class="fin-unmatched-count">{{ warehouses.length }}</span>
        </button>
        <button type="button" class="fin-tab" :class="{ active: tab === 'products' }" @click="tab = 'products'">
          Produkte
          <span class="fin-unmatched-count">{{ products.length }}</span>
        </button>
      </div>

      <div class="fin-drawer-body fin-unmatched-body">
        <div class="fin-unmatched-toolbar">
          <div class="fin-search-wrap" style="flex: 1; min-width: 180px">
            <i class="fa fa-search fin-search-icon"></i>
            <input v-model="search" class="fin-input" type="text" :placeholder="searchPlaceholder" />
          </div>
          <button type="button" class="fin-btn" :disabled="!filteredRows.length" @click="downloadCurrent">
            <i class="fa fa-download"></i>
            Shkarko këtë listë
          </button>
          <button type="button" class="fin-btn primary" :disabled="!products.length && !warehouses.length" @click="downloadAll">
            <i class="fa fa-file-csv"></i>
            Shkarko të gjitha
          </button>
        </div>

        <p class="fin-hint" style="margin: 0 0 10px">{{ tabHint }}</p>

        <div class="fin-unmatched-table-wrap">
          <table class="fin-mini-table fin-unmatched-table">
            <thead>
              <tr>
                <th>Kodi Financa</th>
                <th class="is-num">Rreshta stok</th>
                <th class="is-num">Sasia</th>
              </tr>
            </thead>
            <tbody v-if="filteredRows.length">
              <tr v-for="row in filteredRows" :key="tab + '-' + row.code">
                <td><code class="fin-code">{{ row.code }}</code></td>
                <td class="is-num">{{ formatQty(row.rows) }}</td>
                <td class="is-num">{{ formatQty(row.qty) }}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="3" class="fin-empty" style="padding: 28px">
                  {{ search.trim() ? "Asnjë kod nuk përputhet me kërkimin." : emptyLabel }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="fin-modal-foot">
        <span class="fin-unmatched-foot-meta">{{ filteredRows.length }} / {{ currentRows.length }} kode</span>
        <button type="button" class="fin-btn" @click="$emit('close')">Mbyll</button>
      </div>
    </div>
  </div>
</template>

<script>
import formatMixin from "../shared/formatMixin.js";

export default {
  name: "FinancaUnmatchedModal",
  mixins: [formatMixin],
  props: {
    products: { type: Array, default: () => [] },
    warehouses: { type: Array, default: () => [] },
  },
  emits: ["close"],
  data() {
    return {
      tab: "warehouses",
      search: "",
    };
  },
  computed: {
    currentRows() {
      return this.tab === "products" ? this.products : this.warehouses;
    },
    filteredRows() {
      const q = this.search.trim().toLowerCase();
      if (!q) return this.currentRows;
      return this.currentRows.filter((row) => String(row.code || "").toLowerCase().includes(q));
    },
    searchPlaceholder() {
      return this.tab === "products" ? "Kërko kod produkti (KOD)..." : "Kërko kod magazine (KMAG)...";
    },
    tabHint() {
      return this.tab === "products"
        ? "Këto kode artikulli nga Financa nuk përputhen me asnjë produkt (products.code). Krijo kartelën ose ndreq kodin."
        : "Këto kode KMAG nga Financa nuk përputhen me asnjë magazinë (Kodi f2). Vendosi te kartela e magazines.";
    },
    emptyLabel() {
      return this.tab === "products" ? "Të gjitha produktet u përputhën." : "Të gjitha magazinat u përputhën.";
    },
  },
  created() {
    if (!this.warehouses.length && this.products.length) this.tab = "products";
  },
  methods: {
    csvCell(value) {
      const text = String(value ?? "");
      if (/[",;\n]/.test(text)) return '"' + text.replace(/"/g, '""') + '"';
      return text;
    },
    toCsv(headers, rows) {
      const lines = [headers.map(this.csvCell).join(";")];
      rows.forEach((row) => lines.push(row.map(this.csvCell).join(";")));
      return "\uFEFF" + lines.join("\n");
    },
    saveCsv(filename, content) {
      const url = window.URL.createObjectURL(new Blob([content], { type: "text/csv;charset=utf-8" }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
    stamp() {
      const now = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      return now.getFullYear() + pad(now.getMonth() + 1) + pad(now.getDate());
    },
    mapRows(kind, rows) {
      return rows.map((row) => [kind, row.code, row.rows ?? 0, row.qty ?? 0]);
    },
    downloadCurrent() {
      const kind = this.tab === "products" ? "produkt" : "magazine";
      const headers = ["lloji", "kodi_financa", "rreshta_stok", "sasia"];
      this.saveCsv(
        "financa-" + kind + "-pa-mapim-" + this.stamp() + ".csv",
        this.toCsv(headers, this.mapRows(kind, this.filteredRows))
      );
    },
    downloadAll() {
      const headers = ["lloji", "kodi_financa", "rreshta_stok", "sasia"];
      const rows = this.mapRows("magazine", this.warehouses).concat(this.mapRows("produkt", this.products));
      this.saveCsv("financa-kode-pa-mapim-" + this.stamp() + ".csv", this.toCsv(headers, rows));
    },
  },
};
</script>
